import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  CircularProgress,
  Typography,
  Box,
  TablePagination,
  Grid,
  Stack,
} from "@mui/material";
import { motion } from "framer-motion";
import ClearIcon from "@mui/icons-material/Clear";
import { IconButton } from "@mui/material";
import check from "../../../Components/Assets/images/checkimg.jpg";
import wrong from "../../../Components/Assets/images/wrongimg.jpg";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
// import IconButton from "@mui/material/IconButton";
import Swal from "sweetalert2";
const CouponsTable = ({
  couponsData,
  loading,
  searchBy,
  search,
  page,
  perPage,
  total,
  setCouponsData,
  SetLoading,
  setSearchBy,
  setSearch,
  setPage,
  setPerPage,
  setTotal,
  handleEdit,
}) => {
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleView = (coupon) => {
    if (!coupon.items || coupon.items.length === 0) return;

    const itemsHtml = coupon.items
      .map(
        (item, index) =>
          `<div style="margin: 4px 0; font-weight: 500;">${index + 1}. ${
            item.product_name
          }</div>`
      )
      .join("");

    Swal.fire({
      title: "Linked Products",
      html: itemsHtml,
      confirmButtonText: "Close",
      width: 400,
    });
  };

  return (
    <Box sx={{ width: "100%" }}>
      <motion.div
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Grid
          container
          justifyContent="space-between"
          alignItems="center"
          spacing={2}
          sx={{ mb: 2 }}
        >
          <Grid item xs={12} md="auto">
            <Typography variant="h6">Total Coupons: {total}</Typography>
          </Grid>

          <Grid item xs={12} md={6}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <FormControl size="small" fullWidth>
                  <InputLabel>Search By</InputLabel>
                  <Select
                    value={searchBy}
                    onChange={(e) => setSearchBy(e.target.value)}
                    label="Search By"
                  >
                    <MenuItem value="coupon_name">Coupon Name</MenuItem>
                    <MenuItem value="code">Code</MenuItem>
                    <MenuItem value="discount_type">Type</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  size="small"
                  placeholder="Search"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  fullWidth
                  InputProps={{
                    endAdornment: search && (
                      <IconButton
                        size="small"
                        onClick={() => setSearch("")}
                        edge="end"
                      >
                        <ClearIcon fontSize="small" />
                      </IconButton>
                    ),
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </motion.div>

      <Box sx={{ display: { xs: "none", md: "block" } }}>
        {/* Your existing Paper with Table here */}
        <Paper elevation={3}>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow sx={{ backgroundColor: "#2196f3" }}>
                  {[
                    "S.No.",
                    "Coupon Name",
                    "Code",
                    "Discount Type",
                    "Value",
                    "Min Order",
                    "Valid From",
                    "Valid To",
                    "Usage Limit",
                    "Used",
                    "Status",
                    "Action",
                  ].map((header) => (
                    <TableCell
                      key={header}
                      sx={{ color: "white", fontWeight: "bold" }}
                    >
                      {header}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={11} align="center">
                      <CircularProgress />
                    </TableCell>
                  </TableRow>
                ) : couponsData.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={11} align="center">
                      <Typography variant="body2" sx={{ py: 2 }}>
                        No coupons found.
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  couponsData.map((coupon, index) => (
                    <TableRow key={coupon.id}>
                      <TableCell>{page * perPage + index + 1}</TableCell>
                      <TableCell>{coupon.coupon_name}</TableCell>
                      <TableCell>{coupon.code}</TableCell>
                      <TableCell>{coupon.discount_type}</TableCell>
                      <TableCell>
                        {coupon.discount_type === "percentage"
                          ? `${coupon.discount_value}%`
                          : `₹${coupon.discount_value}`}
                      </TableCell>
                      <TableCell>₹{coupon.min_order_amount}</TableCell>
                      <TableCell>
                        {new Date(coupon.valid_from).toDateString()}
                      </TableCell>
                      <TableCell>
                        {new Date(coupon.valid_to).toDateString()}
                      </TableCell>
                      <TableCell>{coupon.usage_limit ?? "∞"}</TableCell>
                      <TableCell>{coupon.used_count}</TableCell>
                      <TableCell align="center">
                        <img
                          src={coupon.is_active ? check : wrong}
                          alt={coupon.is_active ? "Active" : "Inactive"}
                          style={{ width: 24, height: 24 }}
                        />
                      </TableCell>
                      <TableCell>
                        <Stack direction="row" spacing={1}>
                          {coupon.items?.length > 0 && (
                            <IconButton
                              size="small"
                              onClick={() => handleView(coupon)}
                            >
                              <VisibilityIcon color="primary" />
                            </IconButton>
                          )}
                          <IconButton
                            size="small"
                            onClick={() => handleEdit(coupon)}
                          >
                            <EditIcon sx={{ color: "#1976d2" }} />
                          </IconButton>
                          {/* <IconButton
                          size="small"
                          // onClick={() => handleDelete(coupon)}
                        >
                          <DeleteIcon sx={{ color: "red" }} />
                        </IconButton> */}
                        </Stack>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            rowsPerPageOptions={[10, 25, 50, 100]}
            component="div"
            count={total}
            rowsPerPage={perPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </Box>
      <Box sx={{ display: { xs: "block", md: "none" } }}>
        {loading ? (
          <Box display="flex" justifyContent="center" py={4}>
            <CircularProgress />
          </Box>
        ) : couponsData.length === 0 ? (
          <Typography variant="body2" align="center" py={2}>
            No coupons found.
          </Typography>
        ) : (
          couponsData.map((coupon, index) => (
            <Paper key={coupon.id} elevation={2} sx={{ mb: 2, p: 2, mx: 1 }}>
              <Typography variant="subtitle1" fontWeight="bold">
                {page * perPage + index + 1}. {coupon.coupon_name}
              </Typography>
              <Typography variant="body2">Code: {coupon.code}</Typography>
              <Typography variant="body2">
                Type: {coupon.discount_type} (
                {coupon.discount_type === "percentage"
                  ? `${coupon.discount_value}%`
                  : `₹${coupon.discount_value}`}
                )
              </Typography>
              <Typography variant="body2">
                Min Order: ₹{coupon.min_order_amount}
              </Typography>
              <Typography variant="body2">
                Valid: {new Date(coupon.valid_from).toDateString()} →{" "}
                {new Date(coupon.valid_to).toDateString()}
              </Typography>
              <Typography variant="body2">
                Used: {coupon.used_count} / {coupon.usage_limit ?? "∞"}
              </Typography>
              <Box mt={1} display="flex" alignItems="center">
                <img
                  src={coupon.is_active ? check : wrong}
                  alt={coupon.is_active ? "Active" : "Inactive"}
                  style={{ width: 24, height: 24 }}
                />
                {/* <Typography variant="body2">
                  {coupon.is_active ? "Active" : "Inactive"}
                </Typography> */}
              </Box>
              <Stack direction="row" spacing={1} mt={1}>
                {coupon.items?.length > 0 && (
                  <IconButton size="small" onClick={() => handleView(coupon)}>
                    <VisibilityIcon color="primary" />
                  </IconButton>
                )}
                <IconButton size="small" onClick={() => handleEdit(coupon)}>
                  <EditIcon sx={{ color: "#1976d2" }} />
                </IconButton>
                {/* <IconButton size="small" onClick={() => handleDelete(coupon)}>
            <DeleteIcon sx={{ color: "red" }} />
          </IconButton> */}
              </Stack>
            </Paper>
          ))
        )}

        <TablePagination
          component="div"
          count={total}
          rowsPerPage={perPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Box>
    </Box>
  );
};

export default CouponsTable;
